import type { FC } from "react";
import { useGoalsRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import { FilterRowLegacy } from "web_myplann/NotificationCenter/FilterScreen/FilterRowLegacy";
import { FilterRowV2 } from "web_myplann/NotificationCenter/FilterScreen/FilterRowV2";
import type { FilterRowProps } from "web_myplann/NotificationCenter/Types/FilterRowProps";

export const FilterRow: FC<FilterRowProps> = (props) => {
	const hasGoalsRight = useGoalsRightOptional();

	return hasGoalsRight ? (
		<FilterRowV2 {...props} />
	) : (
		<FilterRowLegacy {...props} />
	);
};
